var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateimg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15586",
    "data-name": "Group 15586",
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.542,
    height: 88.273,
    viewBox: "0 0 152.542 88.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14836",
    "data-name": "Group 14836",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14831",
    "data-name": "Group 14831",
    transform: "translate(6.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8542",
    "data-name": "Path 8542",
    d: "M48.008,124.2S34.734,66.473,46.019,52.65c13.274-16.258,46.187-21.805,62.211-10.235S166.7,38.6,177.41,54.626s-2.74,69.922-2.74,69.922Z",
    transform: "translate(-41.472 -36.275)",
    fill: "rgba(16,135,87,0.3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14832",
    "data-name": "Group 14832",
    transform: "translate(73.919 20.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8543",
    "data-name": "Path 8543",
    d: "M393.766,138.533c-1.976-.305-1.056-1.609-2.545-2.166-1.309-.49-3.024.053-4.323.357-2.728.639-1.84-1.085-4.278-1.525-1.978-.357-3.284,1.035-4.635,1.587-1.989.812-1.66-.745-3.855-.729a6.053,6.053,0,0,0-3.829,1.9c-1.1.961-2.3.964-4.28,1.066-1.818.094-3.529.8-.77.966,1.5.088,23.749-.082,28.676-.276,2.207-.087,3.24-.242,3.458-.853C397.677,138.047,394.942,138.715,393.766,138.533Z",
    transform: "translate(-363.803 -135.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14833",
    "data-name": "Group 14833",
    transform: "translate(0 32.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8544",
    "data-name": "Path 8544",
    d: "M38.974,195.756c-1.795-.257-.974-1.449-2.329-1.939-1.192-.431-2.742.078-3.917.367-2.467.607-1.68-.966-3.9-1.341-1.8-.3-2.968.972-4.187,1.485-1.8.756-1.513-.659-3.5-.622a5.49,5.49,0,0,0-3.453,1.763c-.991.882-2.079.9-3.87,1.009-1.648.1-3.192.763-.688.883,1.361.065,21.536-.312,26-.537,2-.1,2.935-.252,3.128-.808C42.516,195.276,40.043,195.909,38.974,195.756Z",
    transform: "translate(-11.813 -192.797)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14834",
    "data-name": "Group 14834",
    transform: "translate(120.49 28.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8545",
    "data-name": "Path 8545",
    d: "M614.14,173.4c-1.884-.336-1-1.776-2.423-2.39-1.248-.54-2.885.059-4.124.4-2.6.706-1.753-1.2-4.077-1.682-1.886-.393-3.135,1.144-4.423,1.753-1.9.9-1.582-.822-3.676-.8-1.692.015-2.942,1.383-3.656,2.1-1.054,1.061-2.2,1.064-4.084,1.177-1.734.1-3.367.887-.736,1.066,1.43.1,22.65-.1,27.351-.315,2.105-.1,3.09-.268,3.3-.943C617.871,172.86,615.261,173.6,614.14,173.4Z",
    transform: "translate(-585.561 -169.657)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14835",
    "data-name": "Group 14835",
    transform: "translate(11.343 8.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8546",
    "data-name": "Path 8546",
    d: "M96.523,78.965c-5.089.081-2.246-2.181-4.407-2.6s-3.616,1.11-5.669.308c-2.178-.851-3.2-2.355-5.911-1.793-.926.193-2.307,1.848-3.325,1.855-1.207.008-1.247-1.413-2.448-1.274-2.467.285-2.611,1.352-4.03,2.406a7.829,7.829,0,0,1-4.091,1.376c-.8-.046-1.769,1.34,1.209,1.341,5.3,0,23.023-.367,29.207-.3C97.805,80.288,99.623,78.916,96.523,78.965Z",
    transform: "translate(-65.825 -74.758)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17331",
    "data-name": "Group 17331",
    transform: "translate(-120.609 -61.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17332",
    "data-name": "Group 17332",
    transform: "translate(160.38 89.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17331-2",
    "data-name": "Group 17331",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148965",
    "data-name": "Rectangle 148965",
    width: 73.197,
    height: 60.525,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17334",
    "data-name": "Group 17334",
    transform: "translate(162.944 134.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17333",
    "data-name": "Group 17333",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148966",
    "data-name": "Rectangle 148966",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17336",
    "data-name": "Group 17336",
    transform: "translate(172.88 134.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17335",
    "data-name": "Group 17335",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148967",
    "data-name": "Rectangle 148967",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17338",
    "data-name": "Group 17338",
    transform: "translate(182.815 134.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17337",
    "data-name": "Group 17337",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148968",
    "data-name": "Rectangle 148968",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17340",
    "data-name": "Group 17340",
    transform: "translate(192.751 134.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17339",
    "data-name": "Group 17339",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148969",
    "data-name": "Rectangle 148969",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17342",
    "data-name": "Group 17342",
    transform: "translate(202.686 94.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17341",
    "data-name": "Group 17341",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148970",
    "data-name": "Rectangle 148970",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17344",
    "data-name": "Group 17344",
    transform: "translate(212.622 94.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17343",
    "data-name": "Group 17343",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148971",
    "data-name": "Rectangle 148971",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17346",
    "data-name": "Group 17346",
    transform: "translate(222.558 94.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17345",
    "data-name": "Group 17345",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148972",
    "data-name": "Rectangle 148972",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17348",
    "data-name": "Group 17348",
    transform: "translate(162.944 104.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17347",
    "data-name": "Group 17347",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148973",
    "data-name": "Rectangle 148973",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17350",
    "data-name": "Group 17350",
    transform: "translate(172.88 104.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17349",
    "data-name": "Group 17349",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148974",
    "data-name": "Rectangle 148974",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17352",
    "data-name": "Group 17352",
    transform: "translate(182.815 104.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17351",
    "data-name": "Group 17351"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148975",
    "data-name": "Rectangle 148975",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17354",
    "data-name": "Group 17354",
    transform: "translate(192.751 104.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17353",
    "data-name": "Group 17353",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148976",
    "data-name": "Rectangle 148976",
    width: 8.455,
    height: 8.455,
    fill: "#158757"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17356",
    "data-name": "Group 17356",
    transform: "translate(202.686 104.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17355",
    "data-name": "Group 17355",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148977",
    "data-name": "Rectangle 148977",
    width: 8.455,
    height: 8.455,
    fill: "#158757"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17358",
    "data-name": "Group 17358",
    transform: "translate(212.622 104.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17357",
    "data-name": "Group 17357"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148978",
    "data-name": "Rectangle 148978",
    width: 8.455,
    height: 8.455,
    fill: "#158757"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17360",
    "data-name": "Group 17360",
    transform: "translate(222.558 104.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17359",
    "data-name": "Group 17359"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148979",
    "data-name": "Rectangle 148979",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17362",
    "data-name": "Group 17362",
    transform: "translate(162.944 114.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17361",
    "data-name": "Group 17361",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148980",
    "data-name": "Rectangle 148980",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17364",
    "data-name": "Group 17364",
    transform: "translate(172.88 114.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17363",
    "data-name": "Group 17363",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148981",
    "data-name": "Rectangle 148981",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17366",
    "data-name": "Group 17366",
    transform: "translate(182.815 114.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17365",
    "data-name": "Group 17365",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148982",
    "data-name": "Rectangle 148982",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17368",
    "data-name": "Group 17368",
    transform: "translate(192.751 114.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17367",
    "data-name": "Group 17367",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148983",
    "data-name": "Rectangle 148983",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17370",
    "data-name": "Group 17370",
    transform: "translate(202.686 114.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17369",
    "data-name": "Group 17369",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148984",
    "data-name": "Rectangle 148984",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17372",
    "data-name": "Group 17372",
    transform: "translate(212.622 114.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17371",
    "data-name": "Group 17371",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148985",
    "data-name": "Rectangle 148985",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17374",
    "data-name": "Group 17374",
    transform: "translate(222.558 114.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17373",
    "data-name": "Group 17373",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148986",
    "data-name": "Rectangle 148986",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17376",
    "data-name": "Group 17376",
    transform: "translate(162.944 123.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17375",
    "data-name": "Group 17375",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148987",
    "data-name": "Rectangle 148987",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17378",
    "data-name": "Group 17378",
    transform: "translate(172.88 123.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17377",
    "data-name": "Group 17377",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148988",
    "data-name": "Rectangle 148988",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17380",
    "data-name": "Group 17380",
    transform: "translate(182.815 123.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17379",
    "data-name": "Group 17379"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148989",
    "data-name": "Rectangle 148989",
    width: 8.455,
    height: 8.455,
    fill: "#158757"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17382",
    "data-name": "Group 17382",
    transform: "translate(192.751 123.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17381",
    "data-name": "Group 17381",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148990",
    "data-name": "Rectangle 148990",
    width: 8.455,
    height: 8.455,
    fill: "#158757"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17384",
    "data-name": "Group 17384",
    transform: "translate(202.686 123.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17383",
    "data-name": "Group 17383",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148991",
    "data-name": "Rectangle 148991",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17386",
    "data-name": "Group 17386",
    transform: "translate(212.622 123.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17385",
    "data-name": "Group 17385"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148992",
    "data-name": "Rectangle 148992",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17388",
    "data-name": "Group 17388",
    transform: "translate(222.558 123.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17387",
    "data-name": "Group 17387"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148993",
    "data-name": "Rectangle 148993",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17390",
    "data-name": "Group 17390",
    transform: "translate(202.721 134.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17389",
    "data-name": "Group 17389",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148994",
    "data-name": "Rectangle 148994",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17392",
    "data-name": "Group 17392",
    transform: "translate(212.657 134.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17391",
    "data-name": "Group 17391",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148995",
    "data-name": "Rectangle 148995",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17394",
    "data-name": "Group 17394",
    transform: "translate(162.944 94.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17393",
    "data-name": "Group 17393",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148996",
    "data-name": "Rectangle 148996",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17396",
    "data-name": "Group 17396",
    transform: "translate(172.88 94.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17395",
    "data-name": "Group 17395",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148997",
    "data-name": "Rectangle 148997",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17398",
    "data-name": "Group 17398",
    transform: "translate(182.815 94.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17397",
    "data-name": "Group 17397",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148998",
    "data-name": "Rectangle 148998",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17400",
    "data-name": "Group 17400",
    transform: "translate(192.751 94.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17399",
    "data-name": "Group 17399",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148999",
    "data-name": "Rectangle 148999",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17402",
    "data-name": "Group 17402",
    transform: "translate(222.558 134.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17401",
    "data-name": "Group 17401",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149000",
    "data-name": "Rectangle 149000",
    width: 8.455,
    height: 8.455,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17404",
    "data-name": "Group 17404",
    transform: "translate(160.38 146.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17403",
    "data-name": "Group 17403",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149001",
    "data-name": "Rectangle 149001",
    width: 73.197,
    height: 3.263,
    fill: "#9fd1ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17406",
    "data-name": "Group 17406",
    transform: "translate(183.501 85.085)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17405",
    "data-name": "Group 17405",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18125",
    "data-name": "Path 18125",
    d: "M306.113,86.073c-.022-.118-.209-.1-.187.021a4.545,4.545,0,0,1-1.7,4.326,4.285,4.285,0,0,1-4.551.349,4.61,4.61,0,0,1-.7-.439,4.748,4.748,0,0,0,1.622-2.152,2.261,2.261,0,0,0-.6-2.627,1.718,1.718,0,0,0-2.273.378,2.7,2.7,0,0,0-.222,2.86,4.247,4.247,0,0,0,1.167,1.536,5.013,5.013,0,0,1-2.453.872,4.885,4.885,0,0,1-3.236-.985,4.8,4.8,0,0,0,1.322-1.96,2.5,2.5,0,0,0-.5-2.776,1.6,1.6,0,0,0-2.3.224,2.641,2.641,0,0,0-.124,2.894,4.925,4.925,0,0,0,1.309,1.627q-.128.106-.262.2a4.741,4.741,0,0,1-4.951.385,4.911,4.911,0,0,1-.536-.318,4.608,4.608,0,0,0,1.151-1.7,2.618,2.618,0,0,0-.416-2.885,1.578,1.578,0,0,0-2.3.114,2.522,2.522,0,0,0-.136,2.846,4.792,4.792,0,0,0,1.4,1.646,4.651,4.651,0,0,1-2.984,1.141,4.577,4.577,0,0,1-3.095-1.271,5.062,5.062,0,0,0,1.073-1.461,2.689,2.689,0,0,0-.025-2.9,1.42,1.42,0,0,0-2.249.18,2.879,2.879,0,0,0,0,2.852,4.773,4.773,0,0,0,.925,1.323,5.106,5.106,0,0,1-.947.665,4.73,4.73,0,0,1-4.8-.176,5.162,5.162,0,0,1-.639-.478,4.333,4.333,0,0,0,1.23-1.793,2.564,2.564,0,0,0-.418-2.768,1.468,1.468,0,0,0-2.24.362,2.947,2.947,0,0,0,.181,2.95,5.008,5.008,0,0,0,.963,1.245,4.347,4.347,0,0,1-2.917.993,4.223,4.223,0,0,1-3.582-2.74,4.055,4.055,0,0,1-.215-2.3c.024-.119-.161-.148-.186-.029a4.564,4.564,0,0,0,1.963,4.581,4.247,4.247,0,0,0,4.882-.221c.065-.048.128-.1.191-.151a4.909,4.909,0,0,0,6.663,0,4.968,4.968,0,0,0,.747.584,4.655,4.655,0,0,0,2.591.745,4.8,4.8,0,0,0,2.627-.892,4.924,4.924,0,0,0,.407-.324,4.876,4.876,0,0,0,6.043-.28,5.411,5.411,0,0,0,.476.326,5.042,5.042,0,0,0,5.444-.17c.022-.015.043-.032.065-.048a4.88,4.88,0,0,0,2.912,1.01,4.616,4.616,0,0,0,4.389-5.382ZM272.8,89.017a2.675,2.675,0,0,1-.1-2.828,1.35,1.35,0,0,1,1.159-.563,1.424,1.424,0,0,1,1.057.746A2.944,2.944,0,0,1,274.7,89.1a4.284,4.284,0,0,1-.939,1.166A4.8,4.8,0,0,1,272.8,89.017Zm6.766.04a2.728,2.728,0,0,1-.054-2.763,1.369,1.369,0,0,1,1.18-.575,1.31,1.31,0,0,1,1.015.821,3.174,3.174,0,0,1-.53,2.792,5,5,0,0,1-.761.915A4.56,4.56,0,0,1,279.564,89.057Zm5.973-.015a2.49,2.49,0,0,1-.1-2.822,1.479,1.479,0,0,1,1.092-.592,1.516,1.516,0,0,1,1.177.589,2.691,2.691,0,0,1,.045,2.859,4.491,4.491,0,0,1-.975,1.3A4.7,4.7,0,0,1,285.537,89.042Zm6.207-.154a2.737,2.737,0,0,1-.259-2.869,1.65,1.65,0,0,1,1.027-.737,1.388,1.388,0,0,1,1.2.377,2.449,2.449,0,0,1,.3,2.8,4.724,4.724,0,0,1-1.192,1.635A4.844,4.844,0,0,1,291.744,88.887Zm6.169.3a2.885,2.885,0,0,1-.292-2.8,1.611,1.611,0,0,1,2.165-.744,2.069,2.069,0,0,1,.6,2.555,4.583,4.583,0,0,1-1.566,2.014A4.192,4.192,0,0,1,297.913,89.187Z",
    transform: "translate(-266.632 -85.085)",
    fill: "#19203f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17408",
    "data-name": "Group 17408",
    transform: "translate(173.796 102.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17407",
    "data-name": "Group 17407",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18126",
    "data-name": "Path 18126",
    d: "M223.425,169.7l-1.394,1.708,4.636,3.8,6.484-8.314-6.536,5.318Z",
    transform: "translate(-222.03 -166.899)",
    fill: "#158757"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17410",
    "data-name": "Group 17410",
    transform: "translate(202.721 113.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17409",
    "data-name": "Group 17409",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18127",
    "data-name": "Path 18127",
    d: "M356.348,216.758l-1.394,1.708,4.636,3.8,6.484-8.314-6.536,5.318Z",
    transform: "translate(-354.954 -213.952)",
    fill: "#158757"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17412",
    "data-name": "Group 17412",
    transform: "translate(202.487 132.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17411",
    "data-name": "Group 17411",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18128",
    "data-name": "Path 18128",
    d: "M355.272,307.19l-1.394,1.708,4.636,3.8L365,304.384l-6.536,5.318Z",
    transform: "translate(-353.878 -304.384)",
    fill: "#158757"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 3.66,
    cy: 3.66,
    r: 3.66,
    transform: "translate(183.383 94.797)",
    fill: "#158757"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_16124",
    "data-name": "Group 16124",
    transform: "translate(-539.1 -625.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14865",
    "data-name": "Group 14865",
    transform: "translate(576.531 704.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14856",
    "data-name": "Group 14856",
    transform: "translate(6.066 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8561",
    "data-name": "Path 8561",
    d: "M78.185,414.593c.392-.586.621-1.311,1.21-1.688.854-.547,1.959-.091,2.919.236a7.455,7.455,0,0,0,4.1.3,2.048,2.048,0,0,1,1.728.125,5.164,5.164,0,0,0,2.242.408c3.192-.22,5.376-4.193,8.562-3.892,2.394.227,3.97,2.816,6.328,3.292,2.719.549,5.052-1.835,7.63-2.859,6.309-2.507,13.194,3.36,19.9,2.292,3.859-.615,14.692,5.636.739,5.916-7.561.152-14.569-.155-22.131-.152-6.006,0-12.163.225-18.168.227-5.139,0-9.213-.16-14.35-.3a35.543,35.543,0,0,0-7.377-.085,1.23,1.23,0,0,1-.343-.188.969.969,0,0,1-.137-1.109,2.551,2.551,0,0,1,2.039-1.316,22.606,22.606,0,0,1,2.533-.028,3.256,3.256,0,0,0,2.32-.844A2.582,2.582,0,0,0,78.185,414.593Z",
    transform: "translate(-70.926 -409.883)",
    fill: "#4c7722"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14857",
    "data-name": "Group 14857",
    transform: "translate(48.938 3.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8562",
    "data-name": "Path 8562",
    d: "M310.317,429.912c-.022.038.87-.031,1.258.34.591.564,1.669,2.97,1.107,3.9C312.624,432.24,310.312,429.895,310.317,429.912Z",
    transform: "translate(-310.317 -429.911)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14858",
    "data-name": "Group 14858",
    transform: "translate(20.149 1.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8563",
    "data-name": "Path 8563",
    d: "M152.652,417.306c.027.047-1.066-.038-1.541.416-.723.691-2.045,3.638-1.356,4.772C149.827,420.157,152.658,417.285,152.652,417.306Z",
    transform: "translate(-149.562 -417.305)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14861",
    "data-name": "Group 14861",
    transform: "translate(66.339 3.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14859",
    "data-name": "Group 14859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8564",
    "data-name": "Path 8564",
    d: "M408.479,432.265a4.318,4.318,0,0,1-.981-3.047C408.685,430.051,408.479,432.265,408.479,432.265Z",
    transform: "translate(-407.476 -429.218)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14860",
    "data-name": "Group 14860",
    transform: "translate(1.176 0.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8565",
    "data-name": "Path 8565",
    d: "M416.546,430.076c.021.038-.864-.031-1.249.337-.586.56-1.657,2.949-1.1,3.869C414.256,432.387,416.551,430.059,416.546,430.076Z",
    transform: "translate(-414.041 -430.075)",
    fill: "#80af1b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14862",
    "data-name": "Group 14862",
    transform: "translate(51.629 4.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8566",
    "data-name": "Path 8566",
    d: "M327.462,433.845c.018.032-.731-.026-1.057.285-.5.474-1.4,2.5-.93,3.275C325.523,435.8,327.466,433.831,327.462,433.845Z",
    transform: "translate(-325.342 -433.845)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14863",
    "data-name": "Group 14863",
    transform: "translate(10.558 3.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8567",
    "data-name": "Path 8567",
    d: "M96.013,427.5a1.961,1.961,0,0,1,.689.22,3.48,3.48,0,0,1,1.7,3.083A13.038,13.038,0,0,0,96.013,427.5Z",
    transform: "translate(-96.013 -427.499)",
    fill: "#80af1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14864",
    "data-name": "Group 14864",
    transform: "translate(0 6.688)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 39.503,
    cy: 1.421,
    rx: 39.503,
    ry: 1.421,
    fill: "#774d1c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateimg);
export default __webpack_public_path__ + "static/media/dateimg.bace88e300948a9b4dddb0599f3e2146.svg";
export { ForwardRef as ReactComponent };